import React, { useEffect, useState } from "react";

import Alert from "./alert";
import style from "./container.styl";
import store from "./store";

type AlertType = {
  id: string;
  type?: "success" | "info";
  message: string;
};

const Container = () => {
  const [alerts, setAlerts] = useState<AlertType[]>([]);

  const update = (alerts: AlertType[]) => {
    setAlerts([...alerts]);
  };

  useEffect(() => {
    store.register(update);

    return () => store.unregister(update);
  }, []);

  return (
    <div className={style.alertContainer}>
      {alerts.map((alert) => (
        <Alert key={alert.id} {...alert} />
      ))}
    </div>
  );
};

export default Container;
